import { useI18n } from '#/i18n/hooks/useI18n';
import { getStaticImageSrc } from '#/utils/getImageSrc';

import { OAuthButton } from './OAuthButton';

type Props = {
  getUrl: () => string | Promise<string>;
};

export function FacebookOAuthButton({ getUrl }: Props) {
  const { i18n } = useI18n();

  return (
    <OAuthButton
      imgSrc={getStaticImageSrc('icons/social/facebook-new.svg')}
      imgAlt="Facebook"
      text={i18n('Continue with Facebook')}
      getUrl={getUrl}
      qaId="facebook-oauth"
    />
  );
}
